import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

class Ella extends React.Component {
    
    render() {
        return (
            <div>
                <h1>Get a better birth control method!</h1>
                <div>
                    <p>Panicking about EC is stressful and unnessary. Let’s find a birth control method that’s best for you. </p>
                    <p>Search for your regular doctor’s info</p>
                    <button>Search</button>
                </div>

                <div>
                    <p>Don’t have a regular doctor? Try a drop-in clinic.</p>
                    <p>Search for your regular doctor’s info</p>
                    <button>See list</button>
                </div>
            </div>
        )
    }
}

export default Ella;


// WEBPACK FOOTER //
// ./src/components/screens/BirthControl.js